// Comprehensive mock data for all locations

export interface LocationData {
  code: string
  name: string
  city: string
  metrics: {
    spend: string
    cpc: string
    ctr: string
    leads: string
    cpl: string
  }
  kpis: {
    callAnsweredRatio: { percentage: number; value: string }
    callLeadsWithStatus: { percentage: number; value: string }
    callLeadsSync: { percentage: number; value: string }
    enquiryToBooking: { percentage: number; value: string }
  }
}

export const BRAND_METRICS = {
  spend: '₹11.25M',
  cpc: '₹21.64',
  ctr: '0.96%',
  leads: '101.85K',
  cpl: '₹110.43',
}

export const BRAND_KPIS = {
  callAnsweredRatio: { percentage: 64, value: '35362/55253' },
  callLeadsWithStatus: { percentage: 80, value: '59460/74325' },
  callLeadsSync: { percentage: 37, value: '15584/42118' },
  enquiryToBooking: { percentage: 7, value: '2850/40708' },
}

export const LOCATION_DATA: Record<string, LocationData> = {
  MH401: {
    code: 'MH401',
    name: 'Mumbai Motors',
    city: 'Mumbai',
    metrics: {
      spend: '₹2.25M',
      cpc: '₹19.85',
      ctr: '1.12%',
      leads: '20.37K',
      cpl: '₹105.20',
    },
    kpis: {
      callAnsweredRatio: { percentage: 68, value: '7072/10400' },
      callLeadsWithStatus: { percentage: 82, value: '11892/14500' },
      callLeadsSync: { percentage: 42, value: '3117/7420' },
      enquiryToBooking: { percentage: 8, value: '570/7125' },
    },
  },
  DL302: {
    code: 'DL302',
    name: 'Delhi Auto Hub',
    city: 'Delhi',
    metrics: {
      spend: '₹1.89M',
      cpc: '₹22.40',
      ctr: '0.89%',
      leads: '17.15K',
      cpl: '₹118.65',
    },
    kpis: {
      callAnsweredRatio: { percentage: 61, value: '5960/9770' },
      callLeadsWithStatus: { percentage: 78, value: '10030/12860' },
      callLeadsSync: { percentage: 35, value: '2625/7500' },
      enquiryToBooking: { percentage: 6, value: '428/7130' },
    },
  },
  HR407: {
    code: 'HR407',
    name: 'Koncept Auto',
    city: 'Gurugram',
    metrics: {
      spend: '₹1.68M',
      cpc: '₹20.15',
      ctr: '0.98%',
      leads: '15.28K',
      cpl: '₹109.80',
    },
    kpis: {
      callAnsweredRatio: { percentage: 66, value: '5285/8008' },
      callLeadsWithStatus: { percentage: 81, value: '9180/11333' },
      callLeadsSync: { percentage: 38, value: '2430/6395' },
      enquiryToBooking: { percentage: 7, value: '385/5500' },
    },
  },
  MH201: {
    code: 'MH201',
    name: 'Pune Motors',
    city: 'Pune',
    metrics: {
      spend: '₹1.45M',
      cpc: '₹21.90',
      ctr: '0.92%',
      leads: '13.20K',
      cpl: '₹112.35',
    },
    kpis: {
      callAnsweredRatio: { percentage: 62, value: '4560/7355' },
      callLeadsWithStatus: { percentage: 79, value: '7820/9898' },
      callLeadsSync: { percentage: 34, value: '2040/6000' },
      enquiryToBooking: { percentage: 6, value: '312/5200' },
    },
  },
  TN101: {
    code: 'TN101',
    name: 'Chennai Cars',
    city: 'Chennai',
    metrics: {
      spend: '₹1.52M',
      cpc: '₹23.10',
      ctr: '0.88%',
      leads: '14.85K',
      cpl: '₹115.90',
    },
    kpis: {
      callAnsweredRatio: { percentage: 60, value: '4950/8250' },
      callLeadsWithStatus: { percentage: 77, value: '8540/11090' },
      callLeadsSync: { percentage: 36, value: '2280/6333' },
      enquiryToBooking: { percentage: 7, value: '350/5000' },
    },
  },
}

// Campaigns data per location
export interface Campaign {
  id: string
  name: string
  product: string
  platform: 'Google' | 'Facebook'
  status: 'Active' | 'Paused' | 'Draft'
  budget: string
  spends: string
  leads: string
  cpl: string
  locationCode: string
  locationName: string
}

export const ALL_CAMPAIGNS: Campaign[] = [
  // Mumbai Motors (MH401) - 12 campaigns
  {
    id: 'c1',
    name: 'GGL_XUV700_Mumbai',
    product: 'XUV700',
    platform: 'Google',
    status: 'Active',
    budget: '₹85,000',
    spends: '₹62,450',
    leads: '245',
    cpl: '₹255',
    locationCode: 'MH401',
    locationName: 'Mumbai Motors',
  },
  {
    id: 'c2',
    name: 'MET_Scorpio-N_Mumbai',
    product: 'Scorpio-N',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹72,000',
    spends: '₹54,200',
    leads: '198',
    cpl: '₹274',
    locationCode: 'MH401',
    locationName: 'Mumbai Motors',
  },
  {
    id: 'c3',
    name: 'GGL_Thar_Mumbai',
    product: 'Thar',
    platform: 'Google',
    status: 'Active',
    budget: '₹65,000',
    spends: '₹48,900',
    leads: '167',
    cpl: '₹293',
    locationCode: 'MH401',
    locationName: 'Mumbai Motors',
  },
  {
    id: 'c4',
    name: 'MET_XUV400_Mumbai',
    product: 'XUV400',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹58,000',
    spends: '₹42,100',
    leads: '156',
    cpl: '₹270',
    locationCode: 'MH401',
    locationName: 'Mumbai Motors',
  },
  {
    id: 'c5',
    name: 'GGL_BE6_Mumbai',
    product: 'BE6 EV',
    platform: 'Google',
    status: 'Active',
    budget: '₹45,000',
    spends: '₹32,800',
    leads: '112',
    cpl: '₹293',
    locationCode: 'MH401',
    locationName: 'Mumbai Motors',
  },
  {
    id: 'c6',
    name: 'MET_Bolero_Mumbai',
    product: 'Bolero',
    platform: 'Facebook',
    status: 'Paused',
    budget: '₹35,000',
    spends: '₹18,500',
    leads: '78',
    cpl: '₹237',
    locationCode: 'MH401',
    locationName: 'Mumbai Motors',
  },
  {
    id: 'c7',
    name: 'GGL_XUV300_Mumbai',
    product: 'XUV300',
    platform: 'Google',
    status: 'Active',
    budget: '₹42,000',
    spends: '₹31,200',
    leads: '134',
    cpl: '₹233',
    locationCode: 'MH401',
    locationName: 'Mumbai Motors',
  },
  {
    id: 'c8',
    name: 'MET_TharRoxx_Mumbai',
    product: 'Thar Roxx',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹78,000',
    spends: '₹58,400',
    leads: '189',
    cpl: '₹309',
    locationCode: 'MH401',
    locationName: 'Mumbai Motors',
  },
  {
    id: 'c9',
    name: 'GGL_Marazzo_Mumbai',
    product: 'Marazzo',
    platform: 'Google',
    status: 'Draft',
    budget: '₹30,000',
    spends: '₹0',
    leads: '0',
    cpl: '---',
    locationCode: 'MH401',
    locationName: 'Mumbai Motors',
  },
  {
    id: 'c10',
    name: 'MET_Scorpio_Mumbai',
    product: 'Scorpio Classic',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹38,000',
    spends: '₹28,600',
    leads: '98',
    cpl: '₹292',
    locationCode: 'MH401',
    locationName: 'Mumbai Motors',
  },
  {
    id: 'c11',
    name: 'GGL_Retargeting_Mumbai',
    product: 'All Models',
    platform: 'Google',
    status: 'Active',
    budget: '₹25,000',
    spends: '₹19,800',
    leads: '87',
    cpl: '₹228',
    locationCode: 'MH401',
    locationName: 'Mumbai Motors',
  },
  {
    id: 'c12',
    name: 'MET_Festive_Mumbai',
    product: 'All Models',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹55,000',
    spends: '₹41,200',
    leads: '165',
    cpl: '₹250',
    locationCode: 'MH401',
    locationName: 'Mumbai Motors',
  },

  // Delhi Auto Hub (DL302) - 11 campaigns
  {
    id: 'c13',
    name: 'GGL_Scorpio-N_Delhi',
    product: 'Scorpio-N',
    platform: 'Google',
    status: 'Active',
    budget: '₹92,000',
    spends: '₹71,500',
    leads: '278',
    cpl: '₹257',
    locationCode: 'DL302',
    locationName: 'Delhi Auto Hub',
  },
  {
    id: 'c14',
    name: 'MET_Thar_Delhi',
    product: 'Thar',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹68,000',
    spends: '₹52,400',
    leads: '185',
    cpl: '₹283',
    locationCode: 'DL302',
    locationName: 'Delhi Auto Hub',
  },
  {
    id: 'c15',
    name: 'GGL_XUV700_Delhi',
    product: 'XUV700',
    platform: 'Google',
    status: 'Active',
    budget: '₹75,000',
    spends: '₹58,200',
    leads: '212',
    cpl: '₹275',
    locationCode: 'DL302',
    locationName: 'Delhi Auto Hub',
  },
  {
    id: 'c16',
    name: 'MET_BE6_Delhi',
    product: 'BE6 EV',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹48,000',
    spends: '₹35,600',
    leads: '118',
    cpl: '₹302',
    locationCode: 'DL302',
    locationName: 'Delhi Auto Hub',
  },
  {
    id: 'c17',
    name: 'GGL_XUV400_Delhi',
    product: 'XUV400',
    platform: 'Google',
    status: 'Active',
    budget: '₹52,000',
    spends: '₹39,800',
    leads: '145',
    cpl: '₹274',
    locationCode: 'DL302',
    locationName: 'Delhi Auto Hub',
  },
  {
    id: 'c18',
    name: 'MET_Bolero_Delhi',
    product: 'Bolero Neo',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹32,000',
    spends: '₹24,100',
    leads: '102',
    cpl: '₹236',
    locationCode: 'DL302',
    locationName: 'Delhi Auto Hub',
  },
  {
    id: 'c19',
    name: 'GGL_TharRoxx_Delhi',
    product: 'Thar Roxx',
    platform: 'Google',
    status: 'Active',
    budget: '₹82,000',
    spends: '₹64,500',
    leads: '198',
    cpl: '₹326',
    locationCode: 'DL302',
    locationName: 'Delhi Auto Hub',
  },
  {
    id: 'c20',
    name: 'MET_XUV300_Delhi',
    product: 'XUV300',
    platform: 'Facebook',
    status: 'Paused',
    budget: '₹38,000',
    spends: '₹21,200',
    leads: '89',
    cpl: '₹238',
    locationCode: 'DL302',
    locationName: 'Delhi Auto Hub',
  },
  {
    id: 'c21',
    name: 'GGL_Scorpio_Delhi',
    product: 'Scorpio Classic',
    platform: 'Google',
    status: 'Active',
    budget: '₹35,000',
    spends: '₹27,800',
    leads: '112',
    cpl: '₹248',
    locationCode: 'DL302',
    locationName: 'Delhi Auto Hub',
  },
  {
    id: 'c22',
    name: 'MET_Retargeting_Delhi',
    product: 'All Models',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹28,000',
    spends: '₹22,400',
    leads: '95',
    cpl: '₹236',
    locationCode: 'DL302',
    locationName: 'Delhi Auto Hub',
  },
  {
    id: 'c23',
    name: 'GGL_Festive_Delhi',
    product: 'All Models',
    platform: 'Google',
    status: 'Active',
    budget: '₹62,000',
    spends: '₹48,900',
    leads: '178',
    cpl: '₹275',
    locationCode: 'DL302',
    locationName: 'Delhi Auto Hub',
  },

  // Koncept Auto (HR407) - 10 campaigns
  {
    id: 'c24',
    name: 'GGL_TharRoxx_Gurgaon',
    product: 'Thar Roxx',
    platform: 'Google',
    status: 'Active',
    budget: '₹78,000',
    spends: '₹59,200',
    leads: '187',
    cpl: '₹317',
    locationCode: 'HR407',
    locationName: 'Koncept Auto',
  },
  {
    id: 'c25',
    name: 'MET_Scorpio-N_Gurgaon',
    product: 'Scorpio-N',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹65,000',
    spends: '₹48,900',
    leads: '168',
    cpl: '₹291',
    locationCode: 'HR407',
    locationName: 'Koncept Auto',
  },
  {
    id: 'c26',
    name: 'GGL_XUV700_Gurgaon',
    product: 'XUV700',
    platform: 'Google',
    status: 'Active',
    budget: '₹72,000',
    spends: '₹54,600',
    leads: '195',
    cpl: '₹280',
    locationCode: 'HR407',
    locationName: 'Koncept Auto',
  },
  {
    id: 'c27',
    name: 'MET_Thar_Gurgaon',
    product: 'Thar',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹55,000',
    spends: '₹42,100',
    leads: '148',
    cpl: '₹284',
    locationCode: 'HR407',
    locationName: 'Koncept Auto',
  },
  {
    id: 'c28',
    name: 'GGL_Bolero_Gurgaon',
    product: 'Bolero Neo',
    platform: 'Google',
    status: 'Active',
    budget: '₹38,000',
    spends: '₹29,400',
    leads: '125',
    cpl: '₹235',
    locationCode: 'HR407',
    locationName: 'Koncept Auto',
  },
  {
    id: 'c29',
    name: 'MET_XUV400_Gurgaon',
    product: 'XUV400',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹48,000',
    spends: '₹36,200',
    leads: '132',
    cpl: '₹274',
    locationCode: 'HR407',
    locationName: 'Koncept Auto',
  },
  {
    id: 'c30',
    name: 'GGL_BE6_Gurgaon',
    product: 'BE6 EV',
    platform: 'Google',
    status: 'Paused',
    budget: '₹42,000',
    spends: '₹18,500',
    leads: '62',
    cpl: '₹298',
    locationCode: 'HR407',
    locationName: 'Koncept Auto',
  },
  {
    id: 'c31',
    name: 'MET_XUV300_Gurgaon',
    product: 'XUV300',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹35,000',
    spends: '₹27,800',
    leads: '118',
    cpl: '₹236',
    locationCode: 'HR407',
    locationName: 'Koncept Auto',
  },
  {
    id: 'c32',
    name: 'GGL_Retargeting_Gurgaon',
    product: 'All Models',
    platform: 'Google',
    status: 'Active',
    budget: '₹22,000',
    spends: '₹17,600',
    leads: '78',
    cpl: '₹226',
    locationCode: 'HR407',
    locationName: 'Koncept Auto',
  },
  {
    id: 'c33',
    name: 'MET_Festive_Gurgaon',
    product: 'All Models',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹52,000',
    spends: '₹39,800',
    leads: '152',
    cpl: '₹262',
    locationCode: 'HR407',
    locationName: 'Koncept Auto',
  },

  // Pune Motors (MH201) - 10 campaigns
  {
    id: 'c34',
    name: 'GGL_Scorpio-N_Pune',
    product: 'Scorpio-N',
    platform: 'Google',
    status: 'Active',
    budget: '₹62,000',
    spends: '₹47,500',
    leads: '172',
    cpl: '₹276',
    locationCode: 'MH201',
    locationName: 'Pune Motors',
  },
  {
    id: 'c35',
    name: 'MET_XUV700_Pune',
    product: 'XUV700',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹58,000',
    spends: '₹44,200',
    leads: '158',
    cpl: '₹280',
    locationCode: 'MH201',
    locationName: 'Pune Motors',
  },
  {
    id: 'c36',
    name: 'GGL_Thar_Pune',
    product: 'Thar',
    platform: 'Google',
    status: 'Active',
    budget: '₹52,000',
    spends: '₹39,800',
    leads: '138',
    cpl: '₹288',
    locationCode: 'MH201',
    locationName: 'Pune Motors',
  },
  {
    id: 'c37',
    name: 'MET_TharRoxx_Pune',
    product: 'Thar Roxx',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹68,000',
    spends: '₹52,400',
    leads: '165',
    cpl: '₹318',
    locationCode: 'MH201',
    locationName: 'Pune Motors',
  },
  {
    id: 'c38',
    name: 'GGL_XUV400_Pune',
    product: 'XUV400',
    platform: 'Google',
    status: 'Active',
    budget: '₹45,000',
    spends: '₹34,200',
    leads: '128',
    cpl: '₹267',
    locationCode: 'MH201',
    locationName: 'Pune Motors',
  },
  {
    id: 'c39',
    name: 'MET_Bolero_Pune',
    product: 'Bolero',
    platform: 'Facebook',
    status: 'Paused',
    budget: '₹28,000',
    spends: '₹15,600',
    leads: '68',
    cpl: '₹229',
    locationCode: 'MH201',
    locationName: 'Pune Motors',
  },
  {
    id: 'c40',
    name: 'GGL_XUV300_Pune',
    product: 'XUV300',
    platform: 'Google',
    status: 'Active',
    budget: '₹38,000',
    spends: '₹29,400',
    leads: '125',
    cpl: '₹235',
    locationCode: 'MH201',
    locationName: 'Pune Motors',
  },
  {
    id: 'c41',
    name: 'MET_BE6_Pune',
    product: 'BE6 EV',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹42,000',
    spends: '₹31,800',
    leads: '105',
    cpl: '₹303',
    locationCode: 'MH201',
    locationName: 'Pune Motors',
  },
  {
    id: 'c42',
    name: 'GGL_Retargeting_Pune',
    product: 'All Models',
    platform: 'Google',
    status: 'Active',
    budget: '₹20,000',
    spends: '₹15,800',
    leads: '72',
    cpl: '₹219',
    locationCode: 'MH201',
    locationName: 'Pune Motors',
  },
  {
    id: 'c43',
    name: 'MET_Festive_Pune',
    product: 'All Models',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹48,000',
    spends: '₹36,500',
    leads: '142',
    cpl: '₹257',
    locationCode: 'MH201',
    locationName: 'Pune Motors',
  },

  // Chennai Cars (TN101) - 10 campaigns
  {
    id: 'c44',
    name: 'GGL_XUV700_Chennai',
    product: 'XUV700',
    platform: 'Google',
    status: 'Active',
    budget: '₹68,000',
    spends: '₹52,400',
    leads: '185',
    cpl: '₹283',
    locationCode: 'TN101',
    locationName: 'Chennai Cars',
  },
  {
    id: 'c45',
    name: 'MET_Scorpio-N_Chennai',
    product: 'Scorpio-N',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹58,000',
    spends: '₹44,600',
    leads: '162',
    cpl: '₹275',
    locationCode: 'TN101',
    locationName: 'Chennai Cars',
  },
  {
    id: 'c46',
    name: 'GGL_Thar_Chennai',
    product: 'Thar',
    platform: 'Google',
    status: 'Active',
    budget: '₹48,000',
    spends: '₹36,800',
    leads: '128',
    cpl: '₹288',
    locationCode: 'TN101',
    locationName: 'Chennai Cars',
  },
  {
    id: 'c47',
    name: 'MET_XUV400_Chennai',
    product: 'XUV400',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹52,000',
    spends: '₹39,200',
    leads: '145',
    cpl: '₹270',
    locationCode: 'TN101',
    locationName: 'Chennai Cars',
  },
  {
    id: 'c48',
    name: 'GGL_TharRoxx_Chennai',
    product: 'Thar Roxx',
    platform: 'Google',
    status: 'Active',
    budget: '₹72,000',
    spends: '₹55,800',
    leads: '172',
    cpl: '₹324',
    locationCode: 'TN101',
    locationName: 'Chennai Cars',
  },
  {
    id: 'c49',
    name: 'MET_Bolero_Chennai',
    product: 'Bolero Neo',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹32,000',
    spends: '₹24,600',
    leads: '105',
    cpl: '₹234',
    locationCode: 'TN101',
    locationName: 'Chennai Cars',
  },
  {
    id: 'c50',
    name: 'GGL_XUV300_Chennai',
    product: 'XUV300',
    platform: 'Google',
    status: 'Paused',
    budget: '₹35,000',
    spends: '₹18,200',
    leads: '78',
    cpl: '₹233',
    locationCode: 'TN101',
    locationName: 'Chennai Cars',
  },
  {
    id: 'c51',
    name: 'MET_BE6_Chennai',
    product: 'BE6 EV',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹45,000',
    spends: '₹34,500',
    leads: '112',
    cpl: '₹308',
    locationCode: 'TN101',
    locationName: 'Chennai Cars',
  },
  {
    id: 'c52',
    name: 'GGL_Retargeting_Chennai',
    product: 'All Models',
    platform: 'Google',
    status: 'Active',
    budget: '₹24,000',
    spends: '₹19,200',
    leads: '85',
    cpl: '₹226',
    locationCode: 'TN101',
    locationName: 'Chennai Cars',
  },
  {
    id: 'c53',
    name: 'MET_Festive_Chennai',
    product: 'All Models',
    platform: 'Facebook',
    status: 'Active',
    budget: '₹55,000',
    spends: '₹42,800',
    leads: '168',
    cpl: '₹255',
    locationCode: 'TN101',
    locationName: 'Chennai Cars',
  },
]

// Leads data per location
export interface Lead {
  id: number
  name: string
  initials: string
  type: string
  email: string
  phone: string
  dealer: string
  dealerCode: string
  carModel: string
  status: 'cold' | 'warm' | 'hot' | 'completed' | 'partial'
  callStatus: 'pending' | 'completed' | 'callback-requested' | 'not-available'
  hasAI: boolean
  aiResponse?: string
  hasRecording: boolean
  recordingDuration?: string
  tags?: string[]
  multiVisit?: boolean
  createdAt: string
}

export const ALL_LEADS: Lead[] = [
  // Mumbai Motors (MH401) - 12 leads
  {
    id: 101,
    name: 'Rajesh Patil',
    initials: 'RP',
    type: 'Test Drive',
    email: 'rajesh.patil@gmail.com',
    phone: '+91 9820145678',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
    carModel: 'XUV700',
    status: 'hot',
    callStatus: 'completed',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: true,
    recordingDuration: '2:45',
    tags: ['Completed'],
    multiVisit: true,
    createdAt: '2 hours ago',
  },
  {
    id: 102,
    name: 'Priya Deshmukh',
    initials: 'PD',
    type: 'Finance Query',
    email: 'priya.d@yahoo.com',
    phone: '+91 9821234567',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
    carModel: 'Scorpio-N',
    status: 'warm',
    callStatus: 'pending',
    hasAI: true,
    aiResponse: 'Analysed By AI',
    hasRecording: false,
    tags: ['Partial'],
    createdAt: '3 hours ago',
  },
  {
    id: 103,
    name: 'Amit Sharma',
    initials: 'AS',
    type: 'Price Inquiry',
    email: 'amit.sharma@outlook.com',
    phone: '+91 9833456789',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
    carModel: 'Thar',
    status: 'cold',
    callStatus: 'callback-requested',
    hasAI: true,
    hasRecording: true,
    recordingDuration: '1:32',
    createdAt: '5 hours ago',
  },
  {
    id: 104,
    name: 'Sneha Kulkarni',
    initials: 'SK',
    type: 'Test Drive',
    email: 'sneha.k@gmail.com',
    phone: '+91 9876543210',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
    carModel: 'XUV400',
    status: 'hot',
    callStatus: 'completed',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '3:15',
    tags: ['Completed'],
    createdAt: 'Yesterday',
  },
  {
    id: 105,
    name: 'Vikram Joshi',
    initials: 'VJ',
    type: 'Exchange Inquiry',
    email: 'vikram.j@rediffmail.com',
    phone: '+91 9845678901',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
    carModel: 'BE6 EV',
    status: 'warm',
    callStatus: 'pending',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: false,
    createdAt: 'Yesterday',
  },
  {
    id: 106,
    name: 'Meera Nair',
    initials: 'MN',
    type: 'Service Booking',
    email: 'meera.nair@gmail.com',
    phone: '+91 9812345678',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
    carModel: 'XUV300',
    status: 'completed',
    callStatus: 'completed',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '4:20',
    tags: ['Completed'],
    createdAt: '2 days ago',
  },
  {
    id: 107,
    name: 'Rahul Mehta',
    initials: 'RM',
    type: 'Test Drive',
    email: 'rahul.mehta@hotmail.com',
    phone: '+91 9867890123',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
    carModel: 'Thar Roxx',
    status: 'hot',
    callStatus: 'completed',
    hasAI: true,
    aiResponse: 'Analysed By AI',
    hasRecording: true,
    recordingDuration: '2:08',
    tags: ['Completed'],
    multiVisit: true,
    createdAt: '2 days ago',
  },
  {
    id: 108,
    name: 'Ananya Patel',
    initials: 'AP',
    type: 'Price Inquiry',
    email: 'ananya.p@gmail.com',
    phone: '+91 9823456789',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
    carModel: 'Scorpio-N',
    status: 'cold',
    callStatus: 'not-available',
    hasAI: true,
    hasRecording: false,
    createdAt: '3 days ago',
  },
  {
    id: 109,
    name: 'Suresh Iyer',
    initials: 'SI',
    type: 'Finance Query',
    email: 'suresh.iyer@yahoo.com',
    phone: '+91 9834567890',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
    carModel: 'XUV700',
    status: 'warm',
    callStatus: 'pending',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '1:45',
    tags: ['Partial'],
    createdAt: '3 days ago',
  },
  {
    id: 110,
    name: 'Kavita Shah',
    initials: 'KS',
    type: 'Test Drive',
    email: 'kavita.shah@gmail.com',
    phone: '+91 9845678012',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
    carModel: 'Bolero',
    status: 'warm',
    callStatus: 'callback-requested',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: true,
    recordingDuration: '0:58',
    createdAt: '4 days ago',
  },
  {
    id: 111,
    name: 'Deepak Verma',
    initials: 'DV',
    type: 'Exchange Inquiry',
    email: 'deepak.v@outlook.com',
    phone: '+91 9856789012',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
    carModel: 'Marazzo',
    status: 'cold',
    callStatus: 'pending',
    hasAI: true,
    hasRecording: false,
    createdAt: '5 days ago',
  },
  {
    id: 112,
    name: 'Pooja Gupta',
    initials: 'PG',
    type: 'Service Booking',
    email: 'pooja.g@gmail.com',
    phone: '+91 9867890234',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
    carModel: 'XUV300',
    status: 'completed',
    callStatus: 'completed',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '2:30',
    tags: ['Completed'],
    createdAt: '1 week ago',
  },

  // Delhi Auto Hub (DL302) - 11 leads
  {
    id: 201,
    name: 'Arun Kumar',
    initials: 'AK',
    type: 'Test Drive',
    email: 'arun.kumar@gmail.com',
    phone: '+91 9811234567',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
    carModel: 'Scorpio-N',
    status: 'hot',
    callStatus: 'completed',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: true,
    recordingDuration: '3:12',
    tags: ['Completed'],
    multiVisit: true,
    createdAt: '1 hour ago',
  },
  {
    id: 202,
    name: 'Neha Singh',
    initials: 'NS',
    type: 'Finance Query',
    email: 'neha.singh@yahoo.com',
    phone: '+91 9812345678',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
    carModel: 'Thar',
    status: 'warm',
    callStatus: 'pending',
    hasAI: true,
    aiResponse: 'Analysed By AI',
    hasRecording: false,
    tags: ['Partial'],
    createdAt: '4 hours ago',
  },
  {
    id: 203,
    name: 'Rohit Malhotra',
    initials: 'RM',
    type: 'Price Inquiry',
    email: 'rohit.m@outlook.com',
    phone: '+91 9823456789',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
    carModel: 'XUV700',
    status: 'cold',
    callStatus: 'callback-requested',
    hasAI: true,
    hasRecording: true,
    recordingDuration: '1:48',
    createdAt: '6 hours ago',
  },
  {
    id: 204,
    name: 'Simran Kaur',
    initials: 'SK',
    type: 'Test Drive',
    email: 'simran.k@gmail.com',
    phone: '+91 9834567890',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
    carModel: 'BE6 EV',
    status: 'hot',
    callStatus: 'completed',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '2:55',
    tags: ['Completed'],
    createdAt: 'Yesterday',
  },
  {
    id: 205,
    name: 'Manish Gupta',
    initials: 'MG',
    type: 'Exchange Inquiry',
    email: 'manish.g@rediffmail.com',
    phone: '+91 9845678901',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
    carModel: 'XUV400',
    status: 'warm',
    callStatus: 'pending',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: false,
    createdAt: 'Yesterday',
  },
  {
    id: 206,
    name: 'Priyanka Sharma',
    initials: 'PS',
    type: 'Service Booking',
    email: 'priyanka.s@gmail.com',
    phone: '+91 9856789012',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
    carModel: 'Bolero Neo',
    status: 'completed',
    callStatus: 'completed',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '3:45',
    tags: ['Completed'],
    createdAt: '2 days ago',
  },
  {
    id: 207,
    name: 'Vivek Arora',
    initials: 'VA',
    type: 'Test Drive',
    email: 'vivek.a@hotmail.com',
    phone: '+91 9867890123',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
    carModel: 'Thar Roxx',
    status: 'hot',
    callStatus: 'completed',
    hasAI: true,
    aiResponse: 'Analysed By AI',
    hasRecording: true,
    recordingDuration: '2:22',
    tags: ['Completed'],
    multiVisit: true,
    createdAt: '2 days ago',
  },
  {
    id: 208,
    name: 'Anjali Verma',
    initials: 'AV',
    type: 'Price Inquiry',
    email: 'anjali.v@gmail.com',
    phone: '+91 9878901234',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
    carModel: 'XUV300',
    status: 'cold',
    callStatus: 'not-available',
    hasAI: true,
    hasRecording: false,
    createdAt: '3 days ago',
  },
  {
    id: 209,
    name: 'Sanjay Kapoor',
    initials: 'SK',
    type: 'Finance Query',
    email: 'sanjay.k@yahoo.com',
    phone: '+91 9889012345',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
    carModel: 'Scorpio Classic',
    status: 'warm',
    callStatus: 'pending',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '1:35',
    tags: ['Partial'],
    createdAt: '4 days ago',
  },
  {
    id: 210,
    name: 'Ritu Jain',
    initials: 'RJ',
    type: 'Test Drive',
    email: 'ritu.jain@gmail.com',
    phone: '+91 9890123456',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
    carModel: 'XUV700',
    status: 'warm',
    callStatus: 'callback-requested',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: true,
    recordingDuration: '0:52',
    createdAt: '5 days ago',
  },
  {
    id: 211,
    name: 'Karan Bhatia',
    initials: 'KB',
    type: 'Exchange Inquiry',
    email: 'karan.b@outlook.com',
    phone: '+91 9801234567',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
    carModel: 'Thar',
    status: 'cold',
    callStatus: 'pending',
    hasAI: true,
    hasRecording: false,
    createdAt: '1 week ago',
  },

  // Koncept Auto (HR407) - 10 leads
  {
    id: 301,
    name: 'Zainab Khan',
    initials: 'ZK',
    type: 'Test Drive',
    email: 'zainab.k@gmail.com',
    phone: '+91 9019722046',
    dealer: 'Koncept Auto',
    dealerCode: 'HR407',
    carModel: 'Thar Roxx',
    status: 'cold',
    callStatus: 'pending',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: true,
    recordingDuration: '0:32',
    tags: ['Completed'],
    multiVisit: true,
    createdAt: '2 hours ago',
  },
  {
    id: 302,
    name: 'Sunil Yadav',
    initials: 'SY',
    type: 'Invoice',
    email: 'sunil.y@yahoo.com',
    phone: '+91 7011523526',
    dealer: 'Koncept Auto',
    dealerCode: 'HR407',
    carModel: 'Bolero Neo',
    status: 'warm',
    callStatus: 'pending',
    hasAI: true,
    aiResponse: 'Analysed By AI',
    hasRecording: false,
    tags: ['Partial'],
    createdAt: '5 hours ago',
  },
  {
    id: 303,
    name: 'Ankit Chauhan',
    initials: 'AC',
    type: 'Price Inquiry',
    email: 'ankit.c@outlook.com',
    phone: '+91 9773696968',
    dealer: 'Koncept Auto',
    dealerCode: 'HR407',
    carModel: 'Scorpio-N',
    status: 'cold',
    callStatus: 'callback-requested',
    hasAI: true,
    hasRecording: true,
    recordingDuration: '0:32',
    createdAt: 'Yesterday',
  },
  {
    id: 304,
    name: 'Pooja Rani',
    initials: 'PR',
    type: 'Test Drive',
    email: 'pooja.r@gmail.com',
    phone: '+91 9876543210',
    dealer: 'Koncept Auto',
    dealerCode: 'HR407',
    carModel: 'XUV700',
    status: 'hot',
    callStatus: 'completed',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '1:45',
    tags: ['Completed'],
    createdAt: 'Yesterday',
  },
  {
    id: 305,
    name: 'Mohit Taneja',
    initials: 'MT',
    type: 'Finance Query',
    email: 'mohit.t@rediffmail.com',
    phone: '+91 9123456789',
    dealer: 'Koncept Auto',
    dealerCode: 'HR407',
    carModel: 'Thar',
    status: 'warm',
    callStatus: 'pending',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: false,
    createdAt: '2 days ago',
  },
  {
    id: 306,
    name: 'Nisha Aggarwal',
    initials: 'NA',
    type: 'Service Booking',
    email: 'nisha.a@gmail.com',
    phone: '+91 9988776655',
    dealer: 'Koncept Auto',
    dealerCode: 'HR407',
    carModel: 'XUV400',
    status: 'completed',
    callStatus: 'completed',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '2:15',
    tags: ['Completed'],
    createdAt: '3 days ago',
  },
  {
    id: 307,
    name: 'Rajiv Dhawan',
    initials: 'RD',
    type: 'Test Drive',
    email: 'rajiv.d@hotmail.com',
    phone: '+91 9867890123',
    dealer: 'Koncept Auto',
    dealerCode: 'HR407',
    carModel: 'Scorpio-N',
    status: 'hot',
    callStatus: 'completed',
    hasAI: true,
    aiResponse: 'Analysed By AI',
    hasRecording: true,
    recordingDuration: '2:08',
    tags: ['Completed'],
    multiVisit: true,
    createdAt: '4 days ago',
  },
  {
    id: 308,
    name: 'Shweta Malik',
    initials: 'SM',
    type: 'Price Inquiry',
    email: 'shweta.m@gmail.com',
    phone: '+91 9823456789',
    dealer: 'Koncept Auto',
    dealerCode: 'HR407',
    carModel: 'BE6 EV',
    status: 'cold',
    callStatus: 'not-available',
    hasAI: true,
    hasRecording: false,
    createdAt: '5 days ago',
  },
  {
    id: 309,
    name: 'Gaurav Sethi',
    initials: 'GS',
    type: 'Exchange Inquiry',
    email: 'gaurav.s@yahoo.com',
    phone: '+91 9834567890',
    dealer: 'Koncept Auto',
    dealerCode: 'HR407',
    carModel: 'XUV300',
    status: 'warm',
    callStatus: 'pending',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '1:22',
    tags: ['Partial'],
    createdAt: '1 week ago',
  },
  {
    id: 310,
    name: 'Divya Choudhary',
    initials: 'DC',
    type: 'Test Drive',
    email: 'divya.c@gmail.com',
    phone: '+91 9845678012',
    dealer: 'Koncept Auto',
    dealerCode: 'HR407',
    carModel: 'Thar Roxx',
    status: 'warm',
    callStatus: 'callback-requested',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: true,
    recordingDuration: '0:48',
    createdAt: '1 week ago',
  },

  // Pune Motors (MH201) - 10 leads
  {
    id: 401,
    name: 'Sachin Kulkarni',
    initials: 'SK',
    type: 'Test Drive',
    email: 'sachin.k@gmail.com',
    phone: '+91 9820145678',
    dealer: 'Pune Motors',
    dealerCode: 'MH201',
    carModel: 'Scorpio-N',
    status: 'hot',
    callStatus: 'completed',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: true,
    recordingDuration: '2:38',
    tags: ['Completed'],
    multiVisit: true,
    createdAt: '3 hours ago',
  },
  {
    id: 402,
    name: 'Madhuri Joshi',
    initials: 'MJ',
    type: 'Finance Query',
    email: 'madhuri.j@yahoo.com',
    phone: '+91 9821234567',
    dealer: 'Pune Motors',
    dealerCode: 'MH201',
    carModel: 'XUV700',
    status: 'warm',
    callStatus: 'pending',
    hasAI: true,
    aiResponse: 'Analysed By AI',
    hasRecording: false,
    tags: ['Partial'],
    createdAt: '6 hours ago',
  },
  {
    id: 403,
    name: 'Prasad Deshpande',
    initials: 'PD',
    type: 'Price Inquiry',
    email: 'prasad.d@outlook.com',
    phone: '+91 9833456789',
    dealer: 'Pune Motors',
    dealerCode: 'MH201',
    carModel: 'Thar',
    status: 'cold',
    callStatus: 'callback-requested',
    hasAI: true,
    hasRecording: true,
    recordingDuration: '1:15',
    createdAt: 'Yesterday',
  },
  {
    id: 404,
    name: 'Swati Patil',
    initials: 'SP',
    type: 'Test Drive',
    email: 'swati.p@gmail.com',
    phone: '+91 9876543210',
    dealer: 'Pune Motors',
    dealerCode: 'MH201',
    carModel: 'Thar Roxx',
    status: 'hot',
    callStatus: 'completed',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '3:02',
    tags: ['Completed'],
    createdAt: 'Yesterday',
  },
  {
    id: 405,
    name: 'Nitin Bhosale',
    initials: 'NB',
    type: 'Exchange Inquiry',
    email: 'nitin.b@rediffmail.com',
    phone: '+91 9845678901',
    dealer: 'Pune Motors',
    dealerCode: 'MH201',
    carModel: 'XUV400',
    status: 'warm',
    callStatus: 'pending',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: false,
    createdAt: '2 days ago',
  },
  {
    id: 406,
    name: 'Ashwini Kadam',
    initials: 'AK',
    type: 'Service Booking',
    email: 'ashwini.k@gmail.com',
    phone: '+91 9812345678',
    dealer: 'Pune Motors',
    dealerCode: 'MH201',
    carModel: 'Bolero',
    status: 'completed',
    callStatus: 'completed',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '2:45',
    tags: ['Completed'],
    createdAt: '3 days ago',
  },
  {
    id: 407,
    name: 'Vishal Gaikwad',
    initials: 'VG',
    type: 'Test Drive',
    email: 'vishal.g@hotmail.com',
    phone: '+91 9867890123',
    dealer: 'Pune Motors',
    dealerCode: 'MH201',
    carModel: 'XUV300',
    status: 'hot',
    callStatus: 'completed',
    hasAI: true,
    aiResponse: 'Analysed By AI',
    hasRecording: true,
    recordingDuration: '1:58',
    tags: ['Completed'],
    multiVisit: true,
    createdAt: '4 days ago',
  },
  {
    id: 408,
    name: 'Pallavi Shinde',
    initials: 'PS',
    type: 'Price Inquiry',
    email: 'pallavi.s@gmail.com',
    phone: '+91 9823456789',
    dealer: 'Pune Motors',
    dealerCode: 'MH201',
    carModel: 'BE6 EV',
    status: 'cold',
    callStatus: 'not-available',
    hasAI: true,
    hasRecording: false,
    createdAt: '5 days ago',
  },
  {
    id: 409,
    name: 'Ajay Pawar',
    initials: 'AP',
    type: 'Finance Query',
    email: 'ajay.p@yahoo.com',
    phone: '+91 9834567890',
    dealer: 'Pune Motors',
    dealerCode: 'MH201',
    carModel: 'Scorpio-N',
    status: 'warm',
    callStatus: 'pending',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '1:32',
    tags: ['Partial'],
    createdAt: '1 week ago',
  },
  {
    id: 410,
    name: 'Rekha Jadhav',
    initials: 'RJ',
    type: 'Test Drive',
    email: 'rekha.j@gmail.com',
    phone: '+91 9845678012',
    dealer: 'Pune Motors',
    dealerCode: 'MH201',
    carModel: 'XUV700',
    status: 'warm',
    callStatus: 'callback-requested',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: true,
    recordingDuration: '0:55',
    createdAt: '1 week ago',
  },

  // Chennai Cars (TN101) - 11 leads
  {
    id: 501,
    name: 'Karthik Rajan',
    initials: 'KR',
    type: 'Test Drive',
    email: 'karthik.r@gmail.com',
    phone: '+91 9840145678',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
    carModel: 'XUV700',
    status: 'hot',
    callStatus: 'completed',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: true,
    recordingDuration: '2:52',
    tags: ['Completed'],
    multiVisit: true,
    createdAt: '1 hour ago',
  },
  {
    id: 502,
    name: 'Lakshmi Venkat',
    initials: 'LV',
    type: 'Finance Query',
    email: 'lakshmi.v@yahoo.com',
    phone: '+91 9841234567',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
    carModel: 'Scorpio-N',
    status: 'warm',
    callStatus: 'pending',
    hasAI: true,
    aiResponse: 'Analysed By AI',
    hasRecording: false,
    tags: ['Partial'],
    createdAt: '4 hours ago',
  },
  {
    id: 503,
    name: 'Suresh Kumar',
    initials: 'SK',
    type: 'Price Inquiry',
    email: 'suresh.k@outlook.com',
    phone: '+91 9853456789',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
    carModel: 'Thar',
    status: 'cold',
    callStatus: 'callback-requested',
    hasAI: true,
    hasRecording: true,
    recordingDuration: '1:28',
    createdAt: '7 hours ago',
  },
  {
    id: 504,
    name: 'Priya Sundaram',
    initials: 'PS',
    type: 'Test Drive',
    email: 'priya.s@gmail.com',
    phone: '+91 9876543210',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
    carModel: 'XUV400',
    status: 'hot',
    callStatus: 'completed',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '3:18',
    tags: ['Completed'],
    createdAt: 'Yesterday',
  },
  {
    id: 505,
    name: 'Ramesh Iyer',
    initials: 'RI',
    type: 'Exchange Inquiry',
    email: 'ramesh.i@rediffmail.com',
    phone: '+91 9865678901',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
    carModel: 'Thar Roxx',
    status: 'warm',
    callStatus: 'pending',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: false,
    createdAt: 'Yesterday',
  },
  {
    id: 506,
    name: 'Anitha Krishnan',
    initials: 'AK',
    type: 'Service Booking',
    email: 'anitha.k@gmail.com',
    phone: '+91 9832345678',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
    carModel: 'Bolero Neo',
    status: 'completed',
    callStatus: 'completed',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '2:35',
    tags: ['Completed'],
    createdAt: '2 days ago',
  },
  {
    id: 507,
    name: 'Vijay Shankar',
    initials: 'VS',
    type: 'Test Drive',
    email: 'vijay.s@hotmail.com',
    phone: '+91 9887890123',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
    carModel: 'XUV300',
    status: 'hot',
    callStatus: 'completed',
    hasAI: true,
    aiResponse: 'Analysed By AI',
    hasRecording: true,
    recordingDuration: '2:12',
    tags: ['Completed'],
    multiVisit: true,
    createdAt: '3 days ago',
  },
  {
    id: 508,
    name: 'Meenakshi Devi',
    initials: 'MD',
    type: 'Price Inquiry',
    email: 'meenakshi.d@gmail.com',
    phone: '+91 9843456789',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
    carModel: 'BE6 EV',
    status: 'cold',
    callStatus: 'not-available',
    hasAI: true,
    hasRecording: false,
    createdAt: '4 days ago',
  },
  {
    id: 509,
    name: 'Ganesh Murthy',
    initials: 'GM',
    type: 'Finance Query',
    email: 'ganesh.m@yahoo.com',
    phone: '+91 9854567890',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
    carModel: 'Scorpio-N',
    status: 'warm',
    callStatus: 'pending',
    hasAI: false,
    hasRecording: true,
    recordingDuration: '1:42',
    tags: ['Partial'],
    createdAt: '5 days ago',
  },
  {
    id: 510,
    name: 'Saranya Pillai',
    initials: 'SP',
    type: 'Test Drive',
    email: 'saranya.p@gmail.com',
    phone: '+91 9865678012',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
    carModel: 'XUV700',
    status: 'warm',
    callStatus: 'callback-requested',
    hasAI: true,
    aiResponse: 'Answered By AI',
    hasRecording: true,
    recordingDuration: '0:48',
    createdAt: '1 week ago',
  },
  {
    id: 511,
    name: 'Arun Balaji',
    initials: 'AB',
    type: 'Exchange Inquiry',
    email: 'arun.b@outlook.com',
    phone: '+91 9876789012',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
    carModel: 'Thar',
    status: 'cold',
    callStatus: 'pending',
    hasAI: true,
    hasRecording: false,
    createdAt: '1 week ago',
  },
]

// Conversation leads per location
export interface ConversationLead {
  id: number
  name: string
  phone: string
  source: string
  lastMessage: string
  lastMessageTime: string
  unreadCount: number
  aiScore: number
  status: 'active' | 'dormant'
  tags: string[]
  carModel: string
  dealer: string
  dealerCode: string
}

export const ALL_CONVERSATION_LEADS: ConversationLead[] = [
  // Mumbai Motors
  {
    id: 1001,
    name: 'Rahul Sharma',
    phone: '+91 9876543210',
    source: 'whatsapp',
    lastMessage: 'Is the test drive available tomorrow?',
    lastMessageTime: '10:30 AM',
    unreadCount: 2,
    aiScore: 85,
    status: 'active',
    tags: ['Hot Lead'],
    carModel: 'Scorpio-N',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
  },
  {
    id: 1002,
    name: 'Priya Patil',
    phone: '+91 9821234567',
    source: 'web',
    lastMessage: 'Thanks for the brochure.',
    lastMessageTime: 'Yesterday',
    unreadCount: 0,
    aiScore: 65,
    status: 'active',
    tags: ['Warm Lead'],
    carModel: 'XUV700',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
  },
  {
    id: 1003,
    name: 'Amit Deshmukh',
    phone: '+91 9833456789',
    source: 'referral',
    lastMessage: 'What are the EMI options?',
    lastMessageTime: '2 hours ago',
    unreadCount: 1,
    aiScore: 72,
    status: 'active',
    tags: [],
    carModel: 'Thar',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
  },
  {
    id: 1004,
    name: 'Sneha Kulkarni',
    phone: '+91 9845678901',
    source: 'whatsapp',
    lastMessage: 'Can you share the on-road price?',
    lastMessageTime: '3 hours ago',
    unreadCount: 1,
    aiScore: 78,
    status: 'active',
    tags: ['Warm Lead'],
    carModel: 'XUV400',
    dealer: 'Mumbai Motors',
    dealerCode: 'MH401',
  },

  // Delhi Auto Hub
  {
    id: 2001,
    name: 'Arun Kumar',
    phone: '+91 9811234567',
    source: 'whatsapp',
    lastMessage: 'When can I visit for test drive?',
    lastMessageTime: '11:15 AM',
    unreadCount: 3,
    aiScore: 88,
    status: 'active',
    tags: ['Hot Lead'],
    carModel: 'Thar Roxx',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
  },
  {
    id: 2002,
    name: 'Neha Singh',
    phone: '+91 9812345678',
    source: 'web',
    lastMessage: 'Please share finance options',
    lastMessageTime: 'Yesterday',
    unreadCount: 0,
    aiScore: 62,
    status: 'active',
    tags: ['Warm Lead'],
    carModel: 'XUV700',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
  },
  {
    id: 2003,
    name: 'Rohit Malhotra',
    phone: '+91 9823456789',
    source: 'whatsapp',
    lastMessage: 'Is exchange bonus available?',
    lastMessageTime: '4 hours ago',
    unreadCount: 2,
    aiScore: 70,
    status: 'active',
    tags: [],
    carModel: 'Scorpio-N',
    dealer: 'Delhi Auto Hub',
    dealerCode: 'DL302',
  },

  // Koncept Auto
  {
    id: 3001,
    name: 'Zainab Khan',
    phone: '+91 9019722046',
    source: 'whatsapp',
    lastMessage: 'Interested in Thar Roxx',
    lastMessageTime: '9:45 AM',
    unreadCount: 1,
    aiScore: 75,
    status: 'active',
    tags: ['Warm Lead'],
    carModel: 'Thar Roxx',
    dealer: 'Koncept Auto',
    dealerCode: 'HR407',
  },
  {
    id: 3002,
    name: 'Sunil Yadav',
    phone: '+91 7011523526',
    source: 'web',
    lastMessage: 'Need invoice copy',
    lastMessageTime: 'Yesterday',
    unreadCount: 0,
    aiScore: 55,
    status: 'dormant',
    tags: [],
    carModel: 'Bolero Neo',
    dealer: 'Koncept Auto',
    dealerCode: 'HR407',
  },
  {
    id: 3003,
    name: 'Ankit Chauhan',
    phone: '+91 9773696968',
    source: 'referral',
    lastMessage: 'Call me back please',
    lastMessageTime: '5 hours ago',
    unreadCount: 1,
    aiScore: 68,
    status: 'active',
    tags: [],
    carModel: 'Scorpio-N',
    dealer: 'Koncept Auto',
    dealerCode: 'HR407',
  },

  // Pune Motors
  {
    id: 4001,
    name: 'Sachin Kulkarni',
    phone: '+91 9820145678',
    source: 'whatsapp',
    lastMessage: 'Booking amount for Scorpio-N?',
    lastMessageTime: '10:00 AM',
    unreadCount: 2,
    aiScore: 82,
    status: 'active',
    tags: ['Hot Lead'],
    carModel: 'Scorpio-N',
    dealer: 'Pune Motors',
    dealerCode: 'MH201',
  },
  {
    id: 4002,
    name: 'Madhuri Joshi',
    phone: '+91 9821234567',
    source: 'web',
    lastMessage: 'Thanks for the callback',
    lastMessageTime: 'Yesterday',
    unreadCount: 0,
    aiScore: 60,
    status: 'active',
    tags: ['Warm Lead'],
    carModel: 'XUV700',
    dealer: 'Pune Motors',
    dealerCode: 'MH201',
  },
  {
    id: 4003,
    name: 'Prasad Deshpande',
    phone: '+91 9833456789',
    source: 'whatsapp',
    lastMessage: 'Any discounts available?',
    lastMessageTime: '6 hours ago',
    unreadCount: 1,
    aiScore: 65,
    status: 'active',
    tags: [],
    carModel: 'Thar',
    dealer: 'Pune Motors',
    dealerCode: 'MH201',
  },

  // Chennai Cars
  {
    id: 5001,
    name: 'Karthik Rajan',
    phone: '+91 9840145678',
    source: 'whatsapp',
    lastMessage: 'Confirm my test drive slot',
    lastMessageTime: '11:30 AM',
    unreadCount: 1,
    aiScore: 90,
    status: 'active',
    tags: ['Hot Lead'],
    carModel: 'XUV700',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
  },
  {
    id: 5002,
    name: 'Lakshmi Venkat',
    phone: '+91 9841234567',
    source: 'web',
    lastMessage: 'Send loan calculator link',
    lastMessageTime: 'Yesterday',
    unreadCount: 0,
    aiScore: 58,
    status: 'active',
    tags: ['Warm Lead'],
    carModel: 'Scorpio-N',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
  },
  {
    id: 5003,
    name: 'Suresh Kumar',
    phone: '+91 9853456789',
    source: 'referral',
    lastMessage: 'Waiting for your call',
    lastMessageTime: '3 hours ago',
    unreadCount: 2,
    aiScore: 72,
    status: 'active',
    tags: [],
    carModel: 'Thar',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
  },
  {
    id: 5004,
    name: 'Priya Sundaram',
    phone: '+91 9865678901',
    source: 'whatsapp',
    lastMessage: 'What colors are available?',
    lastMessageTime: '5 hours ago',
    unreadCount: 1,
    aiScore: 68,
    status: 'active',
    tags: ['Warm Lead'],
    carModel: 'XUV400',
    dealer: 'Chennai Cars',
    dealerCode: 'TN101',
  },
]
